// src/pages/HistoryStages/HistoryPage2.js
import React from 'react';
import { useNavigate } from 'react-router-dom';
//import '../../../pages/journeybuttons.css'; // Reusing journey styles
import'./HistoryPage.css';
import historyImage from '../../../assets/history2/Mystical_Site_Pictures_-_Wizard_sitting_in_a_beautiful_marble_courtyard_small_fire_in_center_Portals_On_either_side_of_hime_consulting_a_map.png';
console.log('historyImage:', historyImage);
function HistoryPage2() {
  const navigate = useNavigate();

  return (
    <div
      style={{
        backgroundColor: '#000',
        height: '100vh',
        display: 'flex',
        flexDirection: 'column',
        fontFamily: 'sans-serif',
        color: 'white',
      }}
    >
      {/* Top Bar */}
      <div
        className='medieval-text'
        style={{
          height: '5vh',
          backgroundColor: '#111',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          fontSize: '2rem',
        }}
      >

      </div>

      {/* Main Background Area */}
    <div className="history-background-wrapper">
      <img src={historyImage} alt="Historical Scene" className="history-background-image" />



      {/* Back Buttons*/}
      <div className="back-button-wrapper">
        <button
          className="journey-button2"
          title="Return to Campfire"
          onClick={() => navigate('/campfirepage')}
        >
          ⬅ Back
        </button>
      </div>


      {/* Subject Buttons*/}
      <div className="history-button-column">
        <button className="history-button" onClick={() => navigate('/history-Ancient-Civilizations')}>Ancients</button>
        <button className="history-button" onClick={() => navigate('/history-Classical-Antiquity')}>Antiquity</button>
        <button className="history-button" onClick={() => navigate('/history-Middle-Ages')}>Middle Ages</button>
        <button className="history-button" onClick={() => navigate('/history-early-modern')}>Early Modern</button>
        <button className="history-button" onClick={() => navigate('/history-age-of-revolutions')}>Enlightenment</button>
        <button className="history-button" onClick={() => navigate('/history-19th-century')}>1800s</button>
        <button className="history-button" onClick={() => navigate('/history-20th-century')}>1900s</button>
        <button className="history-button" onClick={() => navigate('/history-contemporary')}>Our Times</button>
        <button className="history-button" onClick={() => navigate('/history-host')}>STEM</button>
      </div>




    </div>

      {/* Bottom Bar */}
      <div
        style={{
          height: '7vh',
          backgroundColor: '#111',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          fontSize: '1.2rem',
        }}
      >
      </div>
    
    
    </div>
  );
}

export default HistoryPage2;
